// fallow-ignore-file unused-file -- loaded by snippets/duties-acknowledgement.liquid via asset_url
// Duties acknowledgement: shows the required checkbox to visitors whose IP country
// is outside the shop's country, and saves the choice to the cart straight away so
// it also reaches orders placed with express checkout buttons.
// See snippets/duties-acknowledgement.liquid.
if (!customElements.get('duties-acknowledgement')) {
  let detectedCountry;

  // One lookup per page, shared by every placement and every drawer re-render.
  const detectCountry = () => {
    detectedCountry ??= fetch('/browsing_context_suggestions.json')
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => data?.detected_values?.country?.handle ?? null)
      .catch(() => null);
    return detectedCountry;
  };

  class DutiesAcknowledgement extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="checkbox"]');
      if (!this.input) return;
      this.input.addEventListener('change', this.onChange);
      if (this.hidden) this.showIfAbroad();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('change', this.onChange);
    }

    async showIfAbroad() {
      const country = await detectCountry();
      if (!country || country === this.dataset.homeCountry || !this.isConnected) return;
      this.hidden = false;
      this.input.disabled = false;
    }

    onChange = () => {
      fetch(`${routes.cart_update_url}.js`, {
        ...fetchConfig(),
        body: JSON.stringify({ attributes: { 'Duties Acknowledged': this.input.checked ? 'Yes' : '' } }),
      }).catch(() => {});
    };
  }

  customElements.define('duties-acknowledgement', DutiesAcknowledgement);
}
